import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-background',
  templateUrl: './background.html',
  imports: [CommonModule],
  styleUrls: ['./background.scss'],
})
export class Background implements OnInit {
  skipSafeAreaTop = input(false);

  safeAreaTop = 0;
  safeAreaBottom = 0;

  private readonly route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.safeAreaTop = Number(params['safeAreaTop'] || 0);
      this.safeAreaBottom = Number(params['safeAreaBottom'] || 0);
    });
  }
}
